export const DEFAULT_CUSTOM_TABLE_GROUP_BY = "createdAt";
export const DEFAULT_CUSTOM_TABLE_ORDER_BY = "desc";

const NON_SORTABLE = new Set(["preview", "fileCount"]);

/** Sortable column names for a custom table (excludes preview / attachments). */
export const getSortableColumnNames = (table = {}) => {
  const {columns = [], fileOnly} = table;
  return columns
    .filter(({name}) => {
      if (!name || NON_SORTABLE.has(name)) return false;
      if (fileOnly && name === "fileCount") return false;
      return true;
    })
    .map(({name}) => name);
};

/**
 * Resolve initial BaseTable sort from persisted table defaults.
 * Falls back to createdAt/desc when missing or stale.
 */
export const resolveCustomTableSort = (table = {}) => {
  const sortable = getSortableColumnNames(table);
  const groupBy =
    table.defaultGroupBy &&
    (sortable.includes(table.defaultGroupBy) || table.defaultGroupBy === DEFAULT_CUSTOM_TABLE_GROUP_BY)
      ? table.defaultGroupBy
      : DEFAULT_CUSTOM_TABLE_GROUP_BY;
  const orderBy =
    table.defaultOrderBy === "asc" || table.defaultOrderBy === "desc"
      ? table.defaultOrderBy
      : DEFAULT_CUSTOM_TABLE_ORDER_BY;

  return {groupBy, orderBy};
};
